import React from 'react';

const MobilePopUp = () => {
    return (
        <>
            <div className="c_mobile-pop-up__overlay">
                <img className="c_mobile-pop-up__overlay-img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/overlay.png" />
                <div className="c_mobile-pop-up">
                    <div className="c_mobile-pop-up__body">
                        <div className="c_mobile-pop-up__images">
                            <img className="c_mobile-pop-up__bg" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/mobile/bg.png" />
                        </div>
                        <div className='c_mobile-pop-up__icon'>
                            <img className="c_mobile-pop-up__bg" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/mobile/icon.png" />
                        </div>
                        <div className="c_mobile-pop-up__content">
                            <div className="c_text">
                                <p className='c_mobile-pop-up__title'>Приветствую, друг!</p>
                                <p>К сожалению ты не можешь сейчас выполнять задания, так как их невозможно отобразить на маленьком экране.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MobilePopUp;